import { defineStore } from "pinia";
import $http from "@/api";

export const useUserInfoStore = defineStore("userInfoStore", {
	state: () => {
		return {
			userInfo: {},
		};
	},
	getters: {},
	actions: {
		// 更新用户信息
		async getUserInfo() {
			let res = await $http.login.getMyInfo();
			res && (this.userInfo = res.result || {});
			return res;
		},
		// 清空用户信息
		clearUserInfo() {
			this.userInfo = {};
		},
	},
});
